import React, { useEffect, useState, useRef } from 'react';

const ProgressBar = ({ onFinish, reset }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(0);
  }, [reset]);

  // manter a referência mais recente de onFinish sem recriar o intervalo a cada render
  const onFinishRef = useRef(onFinish);
  useEffect(() => {
    onFinishRef.current = onFinish;
  }, [onFinish]);

  useEffect(() => {
    let mounted = true;
    const interval = setInterval(() => {
      setProgress(prev => {
        if (!mounted) return prev;
        if (prev >= 100) {
          // chama o callback de conclusão usando a referência atualizada
          if (typeof onFinishRef.current === 'function') onFinishRef.current();
          return 0;
        }
        return +(prev + 0.333).toFixed(3);
      });
    }, 100);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
    // reiniciar intervalo apenas quando `reset` mudar
  }, [reset]);

  return (
    <div className="progress-container mb-3">
      <div
        className="progress-bar"
        style={{
          width: `${Math.min(progress, 100)}%`,
          transition: `width 0.1s linear`
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
